
export default function HowItWorks() {
  const steps = [
    {
      number: '1',
      title: 'Submit request',
      description: 'Fill out the form with your company details, target area, and budget range.'
    },
    {
      number: '2',
      title: 'We confirm availability & pricing',
      description: 'Our team reviews your request and sends you placement options within 48 hours.'
    },
    {
      number: '3',
      title: 'You upload creative & pay',
      description: 'Submit your ad creative, complete payment, and your sponsorship goes live.'
    }
  ];

  return (
    <section id="how-it-works" className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-14">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">How it works</h2>
          <p className="text-gray-600 max-w-xl mx-auto">
            Simple, transparent process to get your brand in front of the right audience.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="bg-[#F1ECFF] rounded-xl p-8 h-full">
                <div className="w-12 h-12 bg-gradient-to-r from-[#6B4EFF] to-[#FF4D7D] rounded-full flex items-center justify-center mb-5">
                  <span className="text-white font-bold text-xl">{step.number}</span>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3">{step.title}</h3>
                <p className="text-gray-600 leading-relaxed">{step.description}</p>
              </div>
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
                  <i className="ri-arrow-right-line text-[#6B4EFF] text-2xl" />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
